import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

// component
import EducationOnboarding from './EducationOnboarding';
import {
  getStudentInfo,
  setOnboardingCompletedAt,
} from 'undergraduate-student/actions/education-onboarding';
import {fetchCollegeFields} from 'shared/college-profile/actions/college-profile';

const mapStateToProps = ({collegeSatisfaction, goals}) => ({
  collegeSatisfaction,
  goals,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getStudentInfo,
      setOnboardingCompletedAt,
      fetchCollegeFields,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EducationOnboarding);
